import { combineReducers } from "redux";

import getSkipTour from "./skipTour";

const SkipTourReducer = combineReducers({ getSkipTour });

export default SkipTourReducer;